'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

var _types = require('./types');

var pushCartTypes = _interopRequireWildcard(_types);

var _functional = require('../../../utils/functional');

var _quantityAdjuster = require('../../../modules/quantity-adjuster');

var _quantityAdjuster2 = _interopRequireDefault(_quantityAdjuster);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PushCartItem',

  props: {
    lineItem: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },

  data: function data() {
    return {
      loading: false,
      quantity: this.lineItem.quantity
    };
  },


  computed: (0, _assign2.default)({}, (0, _vuex.mapGetters)({
    initialData: pushCartTypes.GET_INITIAL_DATA
  }), {
    isDiscounted: function isDiscounted() {
      return this.lineItem.final_line_price !== this.lineItem.original_line_price;
    },
    isGiftItem: function isGiftItem() {
      /**
       * @note we have to check the `line_price` here
       * because if a customer adds > 1 gift item, the
       * checkout script splits the item into 2 line
       * items: one with the discount, one without
       */
      return this.lineItem.properties._gift === 'true' && this.isDiscounted;
    },
    isPersonalisationItem: function isPersonalisationItem() {
      return this.lineItem.properties && this.lineItem.properties.__Personalised && this.lineItem.properties.__Personalised === 'true';
    },
    hasQuantityAdjuster: function hasQuantityAdjuster() {
      return this.lineItem.properties['_type'] !== 'Personalisation' && !this.isGiftItem;
    },
    personalisationUid: function personalisationUid() {
      if (!this.isPersonalisationItem) return null;
      if (!this.lineItem.properties['__Child uid']) return null;

      return this.lineItem.properties['__Child uid'];
    },
    linkedItems: function linkedItems() {
      var _this = this;

      if (!this.isPersonalisationItem) return [];

      return this.$parent.lineItems.filter(function (lineItem) {
        return lineItem.properties && lineItem.properties['__Parent uid'] && lineItem.properties['__Parent uid'] === _this.personalisationUid;
      });
    }
  }),

  watch: {
    quantity: function quantity(val) {
      if (this.isPersonalisationItem) {
        return this.handlePersonalisationQuantityChange(val);
      }
      return this.handleQuantityChange(this.lineItem.key, val);
    },


    /**
     * Allow quantity to be updated externally
     */
    lineItem: function lineItem(_lineItem) {
      this.quantity = _lineItem.quantity;
    }
  },

  methods: (0, _assign2.default)({}, (0, _vuex.mapActions)({
    removeItem: pushCartTypes.ACTION__REMOVE_ITEM,
    updateQuantityOfLineItem: pushCartTypes.ACTION__UPDATE_QUANTITY_OF_ITEM,
    updateQuantityOfMultipleLineItems: pushCartTypes.ACTION__UPDATE_QUANTITY_OF_MULTIPLE_ITEMS
  }), {

    formatMoney: _functional.formatMoney,
    resizeImage: _functional.resizeImage,

    handleQuantityChange: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(key, quantity) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                _context.next = 3;
                return this.updateQuantityOfLineItem({
                  key: key,
                  quantity: quantity
                });

              case 3:

                this.loading = false;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleQuantityChange(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return handleQuantityChange;
    }(),
    handlePersonalisationQuantityChange: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(quantity) {
        var personalisedItem;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loading = true;

                personalisedItem = {
                  key: this.linkedItems[0].key
                };
                _context2.next = 4;
                return this.handleQuantityChange(this.lineItem.key, quantity);

              case 4:
                _context2.next = 6;
                return this.handleQuantityChange(personalisedItem.key, this.lineItem.quantity);

              case 6:

                if (quantity > this.lineItem.quantity) {
                  this.quantity = this.lineItem.quantity;
                }

                this.loading = false;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handlePersonalisationQuantityChange(_x3) {
        return _ref2.apply(this, arguments);
      }

      return handlePersonalisationQuantityChange;
    }(),
    handleRemoveItem: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loading = true;

                _context3.next = 3;
                return this.removeItem({ key: this.lineItem.key });

              case 3:

                this.loading = false;

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleRemoveItem() {
        return _ref3.apply(this, arguments);
      }

      return handleRemoveItem;
    }(),
    modifyTitle: function modifyTitle(title) {
      // Remove customiser variant title
      title = title.replace(' - Customiser Variant - Do Not Delete', '');

      return title;
    }
  })
};